import React, { useState, useEffect } from 'react'
// import { fetchAuthSession } from 'aws-amplify/auth'
import { getAuthToken } from '../../../utils/functions.utils'
import { useNavigation } from '@react-navigation/native'
import { apiUrl } from '../../../config/config'
import { useDeviceStore } from '../../../redux/zustand/deviceInfoStore'
import NetInfo from '@react-native-community/netinfo'
import { deleteAllTablesBenefits, getGlobalVersion, openDB, updateGlobalVersion } from '../../../db/indexDB'
import {
    BENEFITS_STORE_NAMES,
    addBenefitVoucher,
    getBenefitsVouchers,
    addRedeem,
    getRedeem,
    addPointsAwarded,
    getPointsAwarded,
} from '../../../db/benefits'

export const useFetchBenefits = () => {
    const API_ENDPOINT = apiUrl + '/get_benefits'
    const { deviceId } = useDeviceStore()
    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState([])
    const [reloadCounter, setReloadCounter] = useState(0)
    const navigation = useNavigation()

    const getToken = async () => {
        try {
            const token = await getAuthToken('benefits_hook')
            return token || ''
        } catch (error) {
            console.error('Error getting token:', error)
            return ''
        }
    }
    const fetch_data = async () => {
        try {
            let data
            const token = await getToken()
            const db = await openDB()

            const netInfoState = await NetInfo.fetch()
            let local_only = false
            let fetch_error = false
            if (netInfoState.isConnected && !local_only) {
                setIsLoading(true)
                const currentGlobalVersion = await getGlobalVersion(db, BENEFITS_STORE_NAMES.BENEFIT_VERSION)
                console.log('🚀 ~ BENEFIT_VERSION ~ currentGlobalVersion:', currentGlobalVersion)

                const response = await fetch(API_ENDPOINT, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: token,
                        version: currentGlobalVersion,
                        // device_key: deviceId,
                    },
                })

                if (!response.ok) {
                    console.error('Fallo al obtener los cursos: ', response)
                    console.log('intento consumir el local de la app')

                    data = {
                        status: 0, // Asume un status 0 que es cuando tiene la misma version que la api
                    }

                    fetch_error = true
                }

                if (!fetch_error) {
                    data = await response.json()

                    // console.log('🚀 ~ ~ 11 data.status:', data.status)
                }
            } else {
                console.log('sin conexion')

                data = {
                    status: 0, // Asume un status 0 que es cuando tiene la misma version que la api
                }
            }

            if (data.status == 0) {
                // consumo local
                let benefit_vouchers = await getBenefitsVouchers(db)
                console.log('🎁 CONSUMO LOCAL DE BENEFICIOS ~ constfetch_data= ~ benefit_vouchers:', benefit_vouchers.length)
                setData(benefit_vouchers)
            } else {
                if (data.status == 1) {
                    if (data['single']['benefits'].length > 0) {
                        setData(data.single['benefits'])
                        data['single']['benefits'].forEach(async (benefit) => {
                            try {
                                await addBenefitVoucher(db, benefit)
                            } catch (error) {
                                console.log('BENEFICIO-------> ~ data.single.data.forEach ~ error:', error)
                            }
                        })
                        await updateGlobalVersion(db, BENEFITS_STORE_NAMES.BENEFIT_VERSION, data.single.data_version)
                        //guardo en local
                    }
                }
            }
            //console.log('🚀 ~ ~ data.status:', data.status)
        } catch (error) {
            console.error('Error obteniendo los beneficios de use fetchBenefits:', error.message, error.stack)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        const unsubscribe = navigation.addListener('focus', () => {
            setReloadCounter((prevCounter) => prevCounter + 1)
        })

        return unsubscribe
    }, [navigation])

    useEffect(() => {
        fetch_data().then(() => {
            setTimeout(() => {
                setIsLoading(false)
            }, 300)
        })
    }, [reloadCounter])

    return {
        data,
        isLoading,
        reload: reloadCounter,
        fetch_data,
        setIsLoading,
    }
}

export const useFetchBenefitHistory = () => {
    const API_ENDPOINT = apiUrl + '/get_benefits_history'
    const { deviceId } = useDeviceStore()
    const [isLoading, setIsLoading] = useState(true)
    const [dataRedeems, setDataRedeems] = useState([])
    const [dataPoints, setDataPoints] = useState([])
    const [points, setPoints] = useState(0)
    const [reloadCounter, setReloadCounter] = useState(0)
    const navigation = useNavigation()

    const getToken = async () => {
        try {
            const token = await getAuthToken('benefits_history_hook')
            return token || ''
        } catch (error) {
            console.error('Error getting token:', error)
            return ''
        }
    }
    const fetch_data = async () => {
        console.log('estoy en fetch_data')

        try {
            let data
            const token = await getToken()
            const db = await openDB()

            const netInfoState = await NetInfo.fetch()
            let local_only = false
            let fetch_error = false
            const currentGlobalVersion = await getGlobalVersion(db, BENEFITS_STORE_NAMES.BENEFIT_HISTORY)
            console.log('🚀 ~ BENEFIT_HISTORY_VERSION ~ currentGlobalVersion:', currentGlobalVersion)
            if (netInfoState.isConnected && !local_only) {
                const response = await fetch(API_ENDPOINT, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: token,
                        version: currentGlobalVersion,
                        // device_key: deviceId,
                    },
                })

                if (!response.ok) {
                    console.error('Fallo al obtener los BENEFITS: ', response)
                    console.log('intento consumir el local de la app')

                    data = {
                        status: 0, // Asume un status 0 que es cuando tiene la misma version que la api
                    }

                    fetch_error = true
                }

                if (!fetch_error) {
                    data = await response.json()

                    // console.log('🚀 ~ ~ 11 data.status:', data.status)
                }
            } else {
                console.log('sin conexion')

                data = {
                    status: 0, // Asume un status 0 que es cuando tiene la misma version que la api
                }
            }

            if (data.status == 0) {
                // consumo local
                let points_user = currentGlobalVersion
                let benefit_redeems = await getRedeem(db)
                let benefit_points = await getPointsAwarded(db)
                let modified_status = benefit_points.map((objeto) => {
                    return {
                        ...objeto,
                        status: 11,
                        image: 'https://resources-one.s3.us-east-2.amazonaws.com/one_sky/assets/folder/pointsEarned.png',
                    }
                })
                console.log('🎁 2 CONSUMO LOCAL DE HISTORY-BENEFICIOS ~=~ :')
                setPoints(points_user)
                setDataRedeems(benefit_redeems)
                setDataPoints(modified_status)
            } else {
                if (data.status == 1) {
                    await deleteAllTablesBenefits()
                    await openDB(true).then(async (res) => {
                        if (data['single']['history_redeems'].length > 0) {
                            setDataRedeems(data.single['history_redeems'].slice(0, 50)) // Limitar a 50 registros
                            let countRedeems = 0
                            for (const benefit of data.single['history_redeems']) {
                                try {
                                    await addRedeem(db, benefit)
                                    countRedeems++
                                    if (countRedeems >= 50) break // Salir después de 50 registros guardados
                                } catch (error) {
                                    console.log('BENEFICIO-------> ~ data.single.data.forEach ~ error:', error)
                                }
                            }
                            // guardar en local
                        }
                        if (data['single']['points_awarded'].length > 0) {
                            let modified_status = data.single['points_awarded'].map((item) => {
                                return {
                                    ...item,
                                    status: 11,
                                    image: 'https://resources-one.s3.us-east-2.amazonaws.com/one_sky/assets/folder/pointsEarned.png',
                                }
                            })
                            setDataPoints(modified_status.slice(0, 50)) // Limitar a 50 registros
                            let countPoints = 0
                            for (const benefit of data.single['points_awarded']) {
                                try {
                                    await addPointsAwarded(db, benefit)
                                    countPoints++
                                    if (countPoints >= 50) break // Salir después de 50 registros guardados
                                } catch (error) {
                                    console.log('BENEFICIO-------> ~ data.single.data.forEach ~ error:', error)
                                }
                            }
                            // guardar en local
                        }
                        //  console.log('🎾 aca llegan nuevos puntos, ', data.single.points)
                        updateGlobalVersion(db, BENEFITS_STORE_NAMES.BENEFIT_HISTORY, data.single.points)
                        setPoints(data.single.points)
                    })
                }
            }

            // setDataPoints(modified_status)
            setIsLoading(false)
            //console.log('🚀 ~ ~ data.status:', data.status)
        } catch (error) {
            console.error('Error obteniendo los beneficios de use fetchBenefits:', error.message, error.stack)
            setIsLoading(false)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        const unsubscribe = navigation.addListener('focus', () => {
            setReloadCounter((prevCounter) => prevCounter + 1)
        })

        return unsubscribe
    }, [navigation])

    useEffect(() => {
        fetch_data().then(() => {
            setTimeout(() => {
                setIsLoading(false)
            }, 300)
        })
    }, [reloadCounter])

    return {
        points,
        dataRedeems,
        dataPoints,
        isLoading,
        reload: reloadCounter,
        fetch_data,
        setIsLoading,
        setReloadCounter: setReloadCounter,
    }
}
